import axios from 'axios'

const RESET = 'RESET'
const SetCofactorData = 'SetCofactorData'
const AddOrEditCofactorAnalyteLink = 'AddOrEditCofactorAnalyteLink'
const DeleteCoFactorAnalyteLink = 'DeleteCoFactorAnalyteLink'
const DeleteCoFactorDefaultValue = 'DeleteCoFactorDefaultValue'
const AddOrEditCoFactorDefaultValue = 'AddOrEditCoFactorDefaultValue'
const AddMissingCoFactorDefaultValue = 'AddMissingCoFactorDefaultValue'
const ChangeDataCheckKey = 'ChangeDataCheckKey'

const BASE_URL_getCoFactor = 'api/CoFactor/Get/'
const BASE_URL_updateCoFactorAnalyteLink = 'api/CoFactor/UpsertCoFactorAnalyteLink'
const BASE_URL_deleteCoFactorAnalyteLink = 'api/CoFactor/DeleteCoFactorAnalyteLink/'
const BASE_URL_deleteCoFactorDefaultValue = 'api/CoFactor/DeleteCoFactorDefaultValue/'
const BASE_URL_upsertCoFactorDefaultValue = 'api/CoFactor/UpsertCoFactorDefaultValue'
const BASE_URL_coFactorDataCheck = 'api/CoFactor/DataCheck/'

function initialState() {
  return {
    cofactorList: [],
    strategyList: [],
    cofactorLinkAnalyte: [],
    dataCheckKey: false,
  }
}

export default {
  namespaced: true,

  state: initialState,

  actions: {
    async getCofactorData({ commit }, options) {
      try {
        var url = BASE_URL_getCoFactor + options
        var res = await axios.get(url)
        commit(SetCofactorData, res.data)
      } catch (error) {
        console.error('Could not get CofactorData from ' + url)
        throw 'Could not get CofactorData.'
      }
    },
    async addOrEditCofactorAnalyteLink({ commit }, options) {
      try {
        var url = BASE_URL_updateCoFactorAnalyteLink
        var cofactorAnalyteLink = {
          CofactorId: options.data.CofactorId,
          AnalyteId: options.data.AnalyteId,
          TenantId: options.data.TenantId,
        }
        var res = await axios.post(url, cofactorAnalyteLink)
        commit(AddOrEditCofactorAnalyteLink, res.data)
        commit(ChangeDataCheckKey)
        options.successCb(res)
      } catch (error) {
        options.failedCb(error)
      }
    },
    async deleteCoFactorAnalyteLink({ commit }, options) {
      try {
        var url = BASE_URL_deleteCoFactorAnalyteLink + options.Id
        var res = await axios.post(url)
        commit(DeleteCoFactorAnalyteLink, options)
        commit(ChangeDataCheckKey)
        options.successCb(res)
      } catch (error) {
        options.failedCb(error)
      }
    },
    async deleteCoFactorDefaultValue({ commit }, options) {
      try {
        var url = BASE_URL_deleteCoFactorDefaultValue + options.Id
        var res = await axios.post(url)
        commit(DeleteCoFactorDefaultValue, options)
        commit(ChangeDataCheckKey)
        options.successCb(res)
      } catch (error) {
        options.failedCb(error)
      }
    },
    async addOrEditCoFactorDefaultValue({ commit }, options) {
      try {
        var url = BASE_URL_upsertCoFactorDefaultValue
        var DefaultValue = {
          TenantId: options.data.TenantId,
          StrategyId: options.data.StrategyId,
          CoFactorDefaultValues: [{
            Id: options.data.CoFactorDefaultValues.Id,
            CoFactorId: options.data.CoFactorDefaultValues.CoFactorId,
            CoFactorName: options.data.CoFactorDefaultValues.CoFactorName,
            DefaultValue: options.data.CoFactorDefaultValues.DefaultValue,
            Unit: options.data.CoFactorDefaultValues.Unit,
            TenantId: options.data.TenantId,
            StrategyId: options.data.StrategyId,
          }],
        }
        var res = await axios.post(url, DefaultValue)
        commit(AddOrEditCoFactorDefaultValue, res.data)
        commit(ChangeDataCheckKey)
        options.successCb(res)
      } catch (error) {
        options.failedCb(error)
      }
    },
    async addMissingCoFactorDefaultValue({ commit }, options) {
      try {
        var url = BASE_URL_upsertCoFactorDefaultValue
        var res = await axios.post(url, options.data)
        commit(AddMissingCoFactorDefaultValue, {data: res.data, isMapSame: options.isMapSame})
        commit(ChangeDataCheckKey)
        options.successCb(res)
      } catch (error) {
        options.failedCb(error)
      }
    },
    async coFactorChecking({ commit }, options) {
      try {
        var url = BASE_URL_coFactorDataCheck + options.data
        var res = await axios.get(url)
        options.successCb(res.data)
      } catch (error) {
        options.failedCb(error)
      }
    },
  },

  mutations: {
    [RESET](state) {
      const s = initialState()
      Object.keys(s).forEach(key => {
        state[key] = s[key]
      })
    },
    [SetCofactorData]: (s, data) => {
      s.cofactorList = data.CoFactorList.sort((a, b) => {
        return a.Name.toLocaleLowerCase().localeCompare(b.Name.toLocaleLowerCase())
      })
      s.strategyList = data.StrategyList
      s.cofactorLinkAnalyte = data.CoFactorAnalyteMaps
    },
    [AddOrEditCofactorAnalyteLink]: (s, data) => {
      let matched = s.cofactorLinkAnalyte.findIndex(x => x.Id == data.Id)
      // add
      if (matched == -1) {
        s.cofactorLinkAnalyte.push({
          Id: data.Id,
          CoFactorId: data.CoFactorId,
          AnalyteId: data.AnalyteId,
        })
      }
      // edit
      else {
        s.cofactorLinkAnalyte.splice(matched, 1, {
          Id: data.Id,
          CoFactorId: data.CoFactorId,
          AnalyteId: data.AnalyteId,
        })
      }
    },
    [DeleteCoFactorAnalyteLink]: (s, data) => {
      let target = s.cofactorLinkAnalyte.findIndex(x => x.Id == data.Id)
      s.cofactorLinkAnalyte.splice(target, 1)
    },
    [DeleteCoFactorDefaultValue](s, data) {
      let targetStrategy = s.strategyList.find(x => x.StrategyCode == data.DataFetchStrategy)
      let targetDefaultValues = targetStrategy.CoFactorDefaultValues.findIndex(x => x.Id == data.Id)
      targetStrategy.CoFactorDefaultValues.splice(targetDefaultValues, 1)
    },
    [AddOrEditCoFactorDefaultValue](s, data) {
      let dc = JSON.parse(JSON.stringify(s.strategyList))
      let targetStrategy = dc.find(x => x.Id == data.StrategyId)
      let matched = targetStrategy.CoFactorDefaultValues.findIndex(x => x.Id == data.CoFactorDefaultValues[0].Id)
      if (matched == -1) {
        // add
        let targetCofactor = s.cofactorList.find(x => x.Id == data.CoFactorDefaultValues[0].CoFactorId)
        targetStrategy.CoFactorDefaultValues.push({
          Id: data.CoFactorDefaultValues[0].Id,
          CoFactorId: data.CoFactorDefaultValues[0].CoFactorId,
          CoFactorName: targetCofactor.Name,
          DefaultValue: data.CoFactorDefaultValues[0].DefaultValue,
          Description: data.CoFactorDefaultValues[0].Description,
          StrategyId: data.CoFactorDefaultValues[0].StrategyId,
          Unit: data.CoFactorDefaultValues[0].Unit,
          TenantId: data.CoFactorDefaultValues[0].TenantId,
        })
      } else {
        // edit
        let targetDefaultValues = targetStrategy.CoFactorDefaultValues.find(x => x.Id == data.CoFactorDefaultValues[0].Id)
        targetDefaultValues.DefaultValue = data.CoFactorDefaultValues[0].DefaultValue
        targetDefaultValues.Unit = data.CoFactorDefaultValues[0].Unit
      }
      s.strategyList = dc
    },
    [AddMissingCoFactorDefaultValue](s, {data, isMapSame}) {
      let targetStrategy = s.strategyList.find(x => x.Id == data.StrategyId)
      if (isMapSame) {
        targetStrategy.CoFactorDefaultValues.forEach((x, index, arr) => {
          if (data.CoFactorDefaultValues.find(y => y.Id == x.Id)) {
            arr[index] = data.CoFactorDefaultValues.find(y => y.Id == x.Id)
          }
        })
        let index = s.strategyList.findIndex(x => x.Id == data.StrategyId)
        s.strategyList.splice(index, 1, targetStrategy)
      } else {
        data.CoFactorDefaultValues.forEach(x => {
          let targetCofactor = s.cofactorList.find(y => y.Id == x.CoFactorId)
          x.CoFactorName = targetCofactor.Name
        })
        targetStrategy.CoFactorDefaultValues = data.CoFactorDefaultValues
      }
    },
    [ChangeDataCheckKey](s) {
      s.dataCheckKey = !s.dataCheckKey
    },
  },

  getters: {
    cofactorList: state => state.cofactorList,
    strategyList: state => state.strategyList,
    cofactorLinkAnalyte: state => state.cofactorLinkAnalyte,
    dataCheckKey: state => state.dataCheckKey,
  },
}